import React from 'react';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { ThemeProvider } from '@mui/material/styles';

import { Button } from '../Buttons/Button';
import './DatePickers.scss';
import newTheme from '../../style/muiTheme';
import { getColorsForColorTheme } from '../../utils/colorTheme';
import { CustomActions } from './DateTimePicker';

function Today(props) {
  const { onSetToday, className } = props;

  return (
    <div className={className} style={{ padding: 8 }}>
      <Button
        id="now-button"
        onClick={onSetToday}
      >
        Today
      </Button>
    </div>
  );
}
Today.propTypes = {
  onSetToday: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default function DatePicker({value, className, showTodayButton, hideClearButton, actions = ['cancel', 'accept', 'today'], ...props}) {
  const theme = React.useMemo(() => {
    const ret = cloneDeep(newTheme(getColorsForColorTheme().mainColor));
    ret.components.MuiOutlinedInput.styleOverrides.root.minWidth = '225px';
    if (!className?.includes('invalid-control-background')) {
      return ret;
    }
    ret.components.MuiTextField.styleOverrides.root.backgroundColor = 'rgba(218, 84, 125, 0.1)';
    return ret;
  }, [className]);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en">
        <MuiDatePicker
          value={value || null}
          placeholder="MM/DD/YYYY"
          formatDensity="spacious"
          slots={{
            actionBar: CustomActions,
          }}
          slotProps={{
            field: { clearable: !hideClearButton },
            actionBar: { actions },
          }}
          {...props}
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
}
DatePicker.propTypes = {
  value: PropTypes.any,
  className: PropTypes.string,
  showTodayButton: PropTypes.bool,
  onChange: PropTypes.func,
  hideClearButton: PropTypes.bool,
};
